/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/no-redundant-roles, react/button-has-type */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import classNames from 'classnames';

import ReactCrop from 'react-image-crop';

import {
  Button, Image, Loader
} from 'semantic-ui-react';

import '../../css/AvatarPicker.less';

import 'react-image-crop/dist/ReactCrop.css';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

import { AVATAR_PICKER_LISTS } from '../../constants';

import Modal from '../Modal';

const TAB_INDEX_AVATARS = 0;
const TAB_INDEX_UPLOAD = 1;
const TAB_INDEX_CROP = 2;

export default
@inject('userManager')
@observer
class AvatarPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: TAB_INDEX_AVATARS,
      avatarPickerName: '',
      //for accessibility we need to set the crop to a default value
      crop: {aspect: 1,height: 70, unit:"px",width: 70, x:1,y:1},
      currentImageName: null,
      loading: false,
      localImgUrl: undefined,
      selectedAvatarIndex: null
    };
    this.ModalBanner = SatCoreComponent('ModalBanner');
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    const { userManager } = this.props;

    const { avatarPickerFacultyName, avatarPickerStudentName, isStudent } = userManager;
    const avatarPickerName = isStudent ? avatarPickerStudentName : avatarPickerFacultyName;

    // Set tabIndex=0 on all <a> tags with class "item"
    const itemLinks = document.querySelectorAll('.ui.attached.tabular.menu a.item');
    itemLinks.forEach((link, index) => {
      link.setAttribute('tabIndex', '0');
      link.setAttribute('role', 'button');
      link.setAttribute('aria-label', 'tab');
      link.setAttribute('data-index', index);
    });

    this.setState({ avatarPickerName });
  }

  handleSelectAvatar = (_event, avatarIndex) => {
    this.setState({ selectedAvatarIndex: avatarIndex });
  };

  handleSelectAvatarKey = (e, avatarIndex) => {
    if (e.key === ' ' || e.key === 'Enter') {
      this.handleSelectAvatar(e, avatarIndex);
    }
  }

  handleTabClick = (index) => {
    this.setState({ activeTab: index });
    // Update aria-selected attributes
    const itemLinks = document.querySelectorAll('.tab-menu a');
    itemLinks.forEach((link, i) => {
      link.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
  }

  handleTabKeyDown = (e, index) => {
    if (e.key === ' ' || e.key === 'Enter') {
      this.handleTabClick(index);
    } else if (e.key === 'ArrowDown') {
      window.scrollBy(0, 100); // Scroll down 100 pixels
    } else if (e.key === 'ArrowUp') {
      window.scrollBy(0, -100); // Scroll up 100 pixels
    }
  }

  handleUploadAvatarKey = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      this.uploadAvatar();
    }
  }

  saveDefault = async () => {
    const { userManager, userId } = this.props;
    const { avatarPickerName, selectedAvatarIndex } = this.state;

    const selectedAvatar = AVATAR_PICKER_LISTS[avatarPickerName]?.[selectedAvatarIndex];

    const selectedAvatarName = selectedAvatar?.name;
    await userManager.saveUserDefaultAvatar(selectedAvatarName, userId);
    this.toggleAvatarEditor();
  };

  toggleAvatarEditor = () => {
    const { props } = this;
    // no need to reset state here - state will be reinitialized each time the AvatarPicker is relaunched
    props.toggleAvatarEditor();
  };

  renderAvatarPane = () => {
    const { avatarPickerName, selectedAvatarIndex } = this.state;

    const avatarPickerList = AVATAR_PICKER_LISTS[avatarPickerName];
    return (
      <div className='avatar-picker-container'>
        <div className='avatar-picker'>
          {avatarPickerList?.map?.((avatarObj, avatarIndex) => {
            const isAvatarSelected = selectedAvatarIndex === avatarIndex;
            return (
              <Image
                key={avatarObj.name}
                alt={avatarObj.alt || ''}
                className={classNames(avatarObj.name, {
                  'selected-avatar': isAvatarSelected
                })}
                name={avatarObj.name}
                onClick={(event) => this.handleSelectAvatar(event, avatarIndex)}
                onKeyDown={(event) => this.handleSelectAvatarKey(event, avatarIndex)}
                src={(avatarObj.src.indexOf('base64') > -1) ? avatarObj.src : require(`./${avatarObj.src}`)}
                tabIndex={0} />
            );
          })}
        </div>
      </div>
    );
  }

  cropImagePane = () => {
    const { activeTab } = this.state;
    return (
      <div className='image-crop-pane'>
        {(activeTab === TAB_INDEX_CROP)
          ? this.renderCropElements()
          : null}
      </div>
    );
  }

  uploadImagePane = () => {
    const { t } = this.props;
    const { loading } = this.state;
    return (
      <div className='image-upload-pane'>
        <button
          aria-label='upload image'
          className='ui button basic upload-button'
          onClick={() => this.fileInputRef.current.click()}
          role='button'
          tabIndex={0}>
          {t('chooseFileFormat')}
        </button>
        <input
          ref={this.fileInputRef}
          accept='image/png, image/jpg'
          className='avatar-file'
          id='avatar-file'
          name='avatar-file'
          onChange={this.uploadAvatar}
          type='file' />
        {this.currentImage()}
        <Loader active={loading} className='modal-loader' inline />
      </div>
    );
  }

  createPanes = () => {
    const { t } = this.props;

    const canUploadOrCropImage = this.canUploadOrCropImage();

    const labelAvatars = t('avatars');

    const avatarPane = {
      menuItem: labelAvatars,
      render: () => this.renderAvatarPane()
    };

    if (canUploadOrCropImage) {
      const labelUploadImage = t('uploadImage');
      const labelCropImage = t('cropImage');

      const uploadPane = { menuItem: labelUploadImage, render: () => <div className='tab-pane'>{this.uploadImagePane()}</div> };
      const cropPane = { menuItem: labelCropImage, render: () => <div className='tab-pane crop-pane'>{this.cropImagePane()}</div> };
      return [avatarPane, uploadPane, cropPane];
    }
    return [avatarPane];
  };

  currentImage = () => {
    const { t, userManager } = this.props;
    const { currentImageName, localImgUrl } = this.state;

    if (localImgUrl) {
      return (<Image className='avatar-current-image' src={localImgUrl} wrapped />);
    } else if (currentImageName) {
      const fullImageUrl = userManager.getFullUrlFromName(currentImageName);
      return (<Image className='avatar-current-image' src={fullImageUrl} wrapped />);
    } else if (userManager.fullProfileImageUrl) {
      const fullImageUrl = userManager.fullProfileImageUrl;
      return (<Image className='avatar-current-image' src={fullImageUrl} wrapped />);
    }
    return (<div className='no-image'>{t('pleaseUploadImageFile')}</div>);
  }

  saveImage = async (newImageName) => {
    const { currentImageName } = this.state;

    const { userId, userManager } = this.props;

    const save = true;
    if (newImageName) {
      await userManager.setProfileImageUrl(newImageName, save, userId);
      this.toggleAvatarEditor();
    } else if (currentImageName) {
      await userManager.setProfileImageUrl(currentImageName, save, userId);
      this.toggleAvatarEditor();
    }
  }

  uploadAvatar = async () => {
    const { avatarPickerName, selectedAvatarIndex, activeTab } = this.state;

    const { t, userManager } = this.props;

    const isDefaultAvatarPickerName = avatarPickerName?.includes?.('DEFAULT');

    // user is uploading an avatar from a non-default picker list
    // e.g. 'AVATAR_PICKER_KYA_LIST' instead of 'AVATAR_PICKER_DEFAULT_LIST'
    if (!isDefaultAvatarPickerName && activeTab === TAB_INDEX_AVATARS) {
      this.setState({ loading: true });

      const avatarObj = AVATAR_PICKER_LISTS[avatarPickerName]?.[selectedAvatarIndex];

      if (!avatarObj) {
        this.toggleAvatarEditor();
        return;
      }

      const imageUrl = (avatarObj.src.indexOf('base64') > -1) ? avatarObj.src : require(`./${avatarObj.src}`);
      const imageResponse = await fetch(imageUrl);
      const blob = await imageResponse.blob();

      const imgFileName = `${avatarObj.name}${(avatarObj.extension || '.png')}`;
      const localImgFile = new File([blob], imgFileName, { type: blob.type });

      const localImgUrl = URL.createObjectURL(localImgFile);

      const formData = new FormData();
      formData.append('contentItemImageSelectLocalImage', localImgFile);

      const result = await userManager.uploadImage(formData);

      if (result) {
        const currentImageName = result;
        this.setState({ currentImageName, loading: false, localImgUrl });

        await this.saveImage(currentImageName);
      } else {
        this.setState({ currentImageName: null, loading: false });
        const errorUploadImage = t('errorUploadImage');
        alert(errorUploadImage); // eslint-disable-line no-alert
      }
    // here we assume user is uploading a custom image (i.e. not from avatar picker)
    } else if (activeTab !== TAB_INDEX_AVATARS) {
      this.setState({ loading: true });
      const formData = new FormData();

      const avatarImgFile = document.getElementById('avatar-file');

      if (!avatarImgFile.files.length) {
        this.setState({ loading: false });
        const selectImageToUpload = t('selectImageToUpload');
        alert(selectImageToUpload); // eslint-disable-line no-alert
        return;
      }

      const localImgFile = avatarImgFile.files[0];
      const localImgUrl = URL.createObjectURL(localImgFile);

      formData.append('contentItemImageSelectLocalImage', localImgFile);

      const result = await userManager.uploadImage(formData);

      if (result) {
        this.setState({ currentImageName: result, loading: false, localImgUrl });
      } else {
        this.setState({ currentImageName: null, loading: false });
        const errorUploadImage = t('errorUploadImage');
        alert(errorUploadImage); // eslint-disable-line no-alert
      }
    }
  };

  loadImage = (image) => {
    this.scaleX = image.naturalWidth / image.width;
    this.scaleY = image.naturalHeight / image.height;
  }

  submitCrop = async () => {
    const { userManager } = this.props;
    const { currentImageName, crop } = this.state;
    if (this.scaleX !== undefined) {
      crop.x *= this.scaleX;
      crop.width *= this.scaleX;
    }

    if (this.scaleY !== undefined) {
      crop.y *= this.scaleY;
      crop.height *= this.scaleY;
    }
    const newImageName = await userManager.submitCrop(currentImageName, crop);
    this.saveImage(newImageName);
  }

  renderCropElements = () => {
    const { userManager } = this.props;
    const { crop, currentImageName, localImgUrl } = this.state;
    const fullUrl = localImgUrl || userManager.getFullUrlFromName(currentImageName);

    if (currentImageName === null && userManager.profileImageUrl === null) {
      return this.currentImage();
    }


    return (
      <div tabIndex={1} className='cropper-container'>
        <ReactCrop circularCrop={true} crop={crop}
          onChange={(newCrop) => this.setCrop(newCrop)}
          onImageLoaded={this.loadImage}
          src={(fullUrl !== null) ? fullUrl : userManager.fullProfileImageUrl} />
      </div>
    );
  }

  setCrop = (crop) => {
    console.log('setCrop', crop);
    this.setState({ crop });
  }

  canUploadOrCropImage() {
    const { userManager } = this.props;
    const {
      isDistrictAdmin, isSchoolAdmin, isProductAdmin, isTeacher, restrictAvatar, restrictAvatarForAllUserTypes
    } = userManager;

    if (restrictAvatarForAllUserTypes) {
      return false;
    }

    const isAdmin = isDistrictAdmin || isSchoolAdmin;
    return isAdmin || isProductAdmin || isTeacher || !restrictAvatar;
  }

  render() {
    const { openAvatarPicker, t } = this.props;
    const { avatarPickerName, saving, activeTab } = this.state;
    const { ModalBanner } = this;

    const showCropper = (activeTab === TAB_INDEX_CROP);
    const showDefault = (activeTab === TAB_INDEX_AVATARS);

    const isDefaultAvatarPickerName = avatarPickerName?.includes?.('DEFAULT');

    let onClickSave;
    if (showCropper) {
      onClickSave = async () => this.submitCrop();
    } else if (showDefault) {
      onClickSave = isDefaultAvatarPickerName ? async () => this.saveDefault() : async () => this.uploadAvatar();
    } else {
      onClickSave = async () => this.saveImage();
    }

    const canUploadOrCropImage = this.canUploadOrCropImage();

    return (
      <Modal
        className='AvatarPickerModal'
        closeOnDimmerClick={false}
        closeOnEscape={true}
        onClose={this.toggleAvatarEditor}
        open={openAvatarPicker}>
        <ModalBanner
          label='Edit Profile Image'
          onClose={this.toggleAvatarEditor} />
        <Modal.Content image scrolling>
          <div className='avatar-picker-parent'>
            <div className='tab-menu' role='tablist'>
              <a aria-selected={activeTab === TAB_INDEX_AVATARS}
                className={classNames('tab-item', { active: activeTab === TAB_INDEX_AVATARS })}
                onClick={() => this.handleTabClick(TAB_INDEX_AVATARS)}
                onKeyDown={(e) => this.handleTabKeyDown(e, TAB_INDEX_AVATARS)}
                role='tab'
                tabIndex={0}>
                {t('avatars')}
              </a>
              {canUploadOrCropImage && (
                <>
                  <a aria-selected={activeTab === TAB_INDEX_UPLOAD}
                    className={classNames('tab-item', { active: activeTab === TAB_INDEX_UPLOAD })}
                    onClick={() => this.handleTabClick(TAB_INDEX_UPLOAD)}
                    onKeyDown={(e) => this.handleTabKeyDown(e, TAB_INDEX_UPLOAD)}
                    role='tab'
                    tabIndex={0}>
                    {t('uploadImage')}
                  </a>
                  <a
                    aria-selected={activeTab === TAB_INDEX_CROP}
                    className={classNames('tab-item', { active: activeTab === TAB_INDEX_CROP })}
                    onClick={() => this.handleTabClick(TAB_INDEX_CROP)}
                    onKeyDown={(e) => this.handleTabKeyDown(e, TAB_INDEX_CROP)}
                    role='tab'
                    tabIndex={0}>
                    {t('cropImage')}
                  </a>
                </>
              )}
            </div>
            <div className='tab-content'>
              {activeTab === TAB_INDEX_AVATARS && this.renderAvatarPane()}
              {activeTab === TAB_INDEX_UPLOAD && this.uploadImagePane()}
              {activeTab === TAB_INDEX_CROP && this.cropImagePane()}
            </div>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button basic className='save-button' disabled={saving}
            onClick={this.toggleAvatarEditor} primary>
            {t('cancel')}
          </Button>
          <Button className='save-button'
            loading={saving}
            onClick={async (_event) => {
              if (!saving) {
                this.setState({ saving: true });
                await onClickSave();
                setTimeout(() => {
                  this.setState({ saving: false });
                }, 500);
              }
            }}
            primary>{(showCropper) ? t('cropAndSave') : t('save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

SatCoreRegister('AvatarPicker', AvatarPicker);
